import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { useTranslation } from "src/_common/hooks/useTranslation";

interface ReportsChartProps {
  data: Array<{
    date: string;
    personalInterview: number;
  }>;
  className?: string;
}

const ReportsChart: React.FC<ReportsChartProps> = ({ data, className }) => {
  const { t } = useTranslation("dashboard");

  // Custom tooltip component
  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <div className="reports-tooltip">
          <p className="tooltip-label">{label}</p>
          <p className="tooltip-value" style={{ color: payload[0].color }}>
            Applications: {payload[0].value}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className={`reports-chart ${className || ""}`}>
      <ResponsiveContainer width="100%" height={400}>
        <LineChart
          data={data}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 60,
          }}
        >
          <CartesianGrid 
            strokeDasharray="3 3" 
            stroke="#e0e0e0"
            horizontal={true}
            vertical={false}
          />
          
          <XAxis 
            dataKey="date"
            axisLine={false}
            tickLine={false}
            tick={{ fill: '#666', fontSize: 11 }}
            angle={0}
            textAnchor="middle"
            interval={0}
            height={60}
          />
          
          <YAxis 
            axisLine={false}
            tickLine={false}
            tick={{ fill: '#666', fontSize: 12 }}
            domain={[0, 100]}
            ticks={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90]}
          />
          
          <Tooltip content={<CustomTooltip />} />
          
          <Line
            type="monotone"
            dataKey="personalInterview"
            stroke="#4caf50"
            strokeWidth={2}
            dot={{ fill: '#4caf50', strokeWidth: 2, r: 4 }}
            activeDot={{ r: 6, fill: '#4caf50' }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ReportsChart;